import { WelcomePage } from "../pages/WelcomePage";
import { NotFound } from "../pages/Not-Found";
import React from "react";
import { Explore } from "../pages/Store";
import { Preferences } from "../pages/Auth/Preferences";
import { Dashboard } from "../pages/Store/Dashboard";
import { Items } from "../pages/Store/Dashboard/Items";
import ReviewList from "../pages/Store/Dashboard/List/ReviewList";
import { ItemRetail } from "../pages/Store/Dashboard/Items/Item/ItemRetail";
import { ActiveList } from "../pages/Store/ActiveList";
import Profile from "pages/Profile/Profile";
import ProfileUpdate from "pages/Profile/ProfileUpdate";
import ContactUs from "pages/Profile/ContactUs";
import Payment from "pages/Order/Payment";
import OnBoarding from "pages/Auth/Preferences/OnBoarding";
import Navbar from "components/Navbar";
import OtpVerification from "pages/Auth/OtpVerification";
import Auth from "pages/Auth";
const routes = [
  {
    name: "NotFound",
    key: "notFound",
    path: "*",
    component: <NotFound />,
    private: false,
  },
  {
    name: "auth",
    key: "auth",
    path: "/auth",
    component: (
      <React.Fragment>
        <Navbar />
        <Auth />
      </React.Fragment>
    ),
    private: false,
  },
  {
    name: "verifyOtp",
    key: "verifyOtp",
    path: "/auth/verify",
    component: (
      <React.Fragment>
        <Navbar />
        <OtpVerification />
      </React.Fragment>
    ),
    private: false,
  },
  {
    name: "WelcomePage",
    key: "welcomePage",
    path: "/:storeId",
    component: (
      <React.Fragment>
        <WelcomePage />
      </React.Fragment>
    ),
    private: false,
  },
  {
    name: "Profile",
    key: "profile",
    path: "/users/:user_id/profile",
    component: (
      <React.Fragment>
        <Navbar title={"Profile"} />
        <Profile />
      </React.Fragment>
    ),
    private: true,
  },
  {
    name: "Update Profile",
    key: "updateProfile",
    path: "/users/:user_id/updateProfile",
    component: (
      <React.Fragment>
        <Navbar title={"Account Info"} />
        <ProfileUpdate />
      </React.Fragment>
    ),
    private: true,
  },
  {
    name: "Contact Us",
    key: "contact",
    path: "/users/:user_id/contact",
    component: (
      <React.Fragment>
        <Navbar title={"Contact Us"} />
        <ContactUs />
      </React.Fragment>
    ),
    private: true,
  },
  {
    name: "Place Order",
    key: "placeOrder",
    path: "/users/:user_id/store/:store_id/lists/:list_id/order",
    component: (
      <React.Fragment>
        <Navbar title={"Place Order"} />
        <Payment />
      </React.Fragment>
    ),
    private: true,
  },
  {
    name: "Explore",
    key: "explore",
    path: "/stores",
    component: (
      <React.Fragment>
        <Navbar />
        <Explore />
      </React.Fragment>
    ),
    private: false,
  },
  {
    name: "StoreDashboard",
    key: "dashboard",
    path: "/stores/:id/dashboard",
    component: (
      <React.Fragment>
        <Navbar title={"Hello,"} />
        <Dashboard />
      </React.Fragment>
    ),
    private: true,
  },
  {
    name: "ReviewActiveList",
    key: "review",
    path: "/stores/:id/lists/:list_id/reviewActiveList",
    component: (
      <React.Fragment>
        <Navbar title={"List Review"} />
        <ActiveList />
      </React.Fragment>
    ),
    private: true,
  },
  {
    name: "ReviewList",
    key: "review",
    path: "/stores/:id/lists/:list_id/review",
    component: (
      <React.Fragment>
        <Navbar title={"List Review"} />
        <ReviewList />
      </React.Fragment>
    ),
    private: true,
  },
  {
    name: "StoreItems",
    key: "items",
    path: "/stores/:id/items",
    component: (
      <React.Fragment>
        <Navbar title={"Search"} />
        <Items />
      </React.Fragment>
    ),
    private: false,
  },
  {
    name: "StoreItems",
    key: "items",
    path: "/stores/:id/items/:item_id/itemRetail",
    component: (
      <React.Fragment>
        <Navbar title={"Butchery"} />
        <ItemRetail />
      </React.Fragment>
    ),
    private: false,
  },
  {
    name: "Preferences",
    key: "preferences",
    path: "/users/:user_id/preferences",
    component: (
      <React.Fragment>
        <Navbar title={""} />
        <Preferences />
      </React.Fragment>
    ),
    private: true,
  },
  {
    name: "User Onboarding",
    key: "onBoarding",
    path: "/users/:user_id/onBoarding",
    component: (
      <React.Fragment>
        <Navbar title={""} />
        <OnBoarding />
      </React.Fragment>
    ),
    private: true,
  },
];

export default routes;
